<template>
  	<template v-if="adblockDetected">
    	<div class="adblockBackground">
      		<div class="adblockWrapper d-flex flex-column justify-content-center align-items-center">
          		<div class="adblockInfoBox">
              		<div class="adblockIcon mb-4">
                  		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
              		</div>
              		<div class="adblockTitle mb-4">
                    	Technologia, której używamy aby naliczać darowizny od zakupów online, jest blokowana przez rozszerzenia typu AdBlock, uBlock, ghostery oraz w oknach prywatnych / incognito niektórych przeglądarek.
              		</div>
              		<div class="adblockInfo mb-4">
                    	Ważne! Dodanie fanimani.pl do wyjątków czy białej listy jest niewystarczające. Niezbędne jest wyłączenie adblocka albo zmiana okna przeglądarki. <a href="https://fanimani.pl/pomoc/dla-uzytkownika/przypominajka/blokery/adblock/" target="_blank">Więcej informacji</a>
              		</div>
              		<div class="adblockButton" v-on:click="adblockRefresh()">
                    	wyłącz adblocka / zmień okno przeglądarki na czas zakupów i odśwież stronę
              		</div>
                  	<div class="text-center mt-4" v-on:click="adblockForce()">
                    	<span class="adblockButtonSmall">chcę przejść do sklepu mimo wszystko</span>
              		</div>
          		</div>
      		</div>
      		<div class="adblockMessage">
          		Nie masz adblocka? <a href="https://fanimani.pl/pomoc/wiadomosc/" target="_blank">Wyślij nam wiadomość</a>
      		</div>
  		</div>
	</template>
    <template v-else>
		<div class="ext-partner-redir" id="ext-partner-redir">
			<template v-if="speedbumpDisplayed">
				<template v-if="partner.id==bookmarkPartner">
					<div class="partner-modal-partner-logo">
						<img :src="partner.thumbnail_url" :alt="partner.name" />
					</div>

					<template v-if="bookmarkStep1">
						<p>
							Komunikatu Przypominajki (rozszerzenia FaniMani) nie zobaczysz na stronie booking.com, ale <strong>cały czas możesz robić darowizny przy okazji rezerwacji na Booking!</strong>
						</p>
						<p>
							Przygotowaliśmy dla Ciebie specjalny link. Dodaj go do Ulubionych.
						</p>
						<button class="btn btn-red" v-on:click="bookmarkGoToStep2()">Dalej <span class="fa fa-chevron-right"></span></button>
						<a :href=redirectUrl class="partner-modal-outside-link" v-on:click="speedbumpAcknowledge($event)">dziękuję, chcę przejść do partnera</a>
					</template>
					<template v-if="bookmarkStep2">
						<p>Wszystko gotowe!</p>

						<p><strong>Dodaj stronę do Ulubionych,<br/>klikając gwiazdę albo wciskając {{bookmarkButton}}+D</strong></p>

						<p>Gdy następnym razem będziesz szukać noclegu, kliknij ikonkę w Ulubionych: przejdziesz do Bookingu już z aktywną darowizną.</p>
						<a :href=redirectUrl class="partner-modal-outside-link" v-on:click="speedbumpAcknowledge($event)">dodałam/em - przejdź do Booking.com</a>
					</template>
				</template>
				<template v-else>
					<header>
						<strong>
						Zanim przejdziesz na stronę {{partner.name}}
						</strong>
					</header>
					<div v-if="!apiError" class="partner-modal-partner-logo">
						<img :src="partner.thumbnail_url" :alt="partner.name" />
					</div>
					<div class="speedbump-items" v-html=speedbumpDescription></div>
					<div class="speedbump-button">
						<a :href=redirectUrl class="btn btn-red" v-on:click="speedbumpAcknowledge($event)">Rozumiem, przechodzę do sklepu <span class="fa fa-chevron-right"></span></a>
					</div>
				</template>
			</template>
			<template v-if="!speedbumpDisplayed">
				<header>
					<strong>
						<span v-if="infoFetched">
							Poczekaj chwilę...
						</span>
						<span v-else-if="apiError === 404">
							Wybrany przez Ciebie sklep jest obecnie niedostępny w FaniMani.
						</span>
						<span v-else-if="apiError">
							Coś poszło nie tak :-(
						</span>
						<span v-else>
							Zapisujemy informacje o darowiźnie...
						</span>
					</strong>
				</header>
				<div v-if="!apiError" class="img-area" :class="{'loading': !infoFetched, 'loaded': infoFetched}">
					<img v-if="infoFetched && partner" class="thumb"
						:src="partner.thumbnail_url" :alt="partner.name" />

					<img class="spinner" :src="staticUrl+'img/loader-2.gif'" alt="Ładowanie..." />
				</div>
			
				<div v-if="infoFetched" class="redir-info">
					<p>
						<em v-html="partner.donation_value_full_html"></em>
						trafi&nbsp;do
						<template v-if="beneficiary">
							<span v-if="beneficiary.id==10">wybranej&nbsp;później&nbsp;organizacji</span>
							<span v-else class="beneficiary-name">{{ beneficiary.name }}</span>
						</template>
						<template v-else>
							<span>wybranej&nbsp;organizacji</span>
						</template>
					</p>
					<template v-if="redirPage === 'mobile' ">
						<p>W sklepie nie będzie widoczna informacja o aktywnej darowiźnie.</p>
					</template>
					<template v-if="partner.fm_ext_footnote">
						<p class="partner-modal-footnote">{{ partner.fm_ext_footnote }}</p>
					</template>
				</div>

				<div v-if="apiError === 404">
					<p>
						<a href="/sklepy/" class="btn btn-red">Wybierz inny sklep <span class="fa fa-chevron-right"></span></a>
					</p>
				</div>
				<div v-else-if="apiError">
					<p class="color-fm-red-2">
						Wróć do sklepu i aktywuj darowiznę jeszcze raz.
					</p>
					<p>
						Jeśli ten problem będzie się&nbsp;powtarzał, powiadom&nbsp;nas o&nbsp;tym e-mailowo na&nbsp;adres:
						<a href="mailto:info@fanimani.pl"><strong>info@fanimani.pl</strong></a>.
					</p>
				</div>
			</template>
		</div>
	</template>
</template>

<script>
	window.clickthrough={
    	partner: null,
    	beneficiary: null
  	};
  	
	import 'whatwg-fetch'
  	import Cookies from 'js-cookie'
  	import queryString from 'query-string'
  	import Vue from 'vue'

	function getDefaultHeaders () {
		let headers = new Headers()
		headers.append('Accept', 'application/json')
		headers.append('Content-Type', 'application/json')
		headers.append('X-CSRFToken', Cookies.get('csrftoken'))
		return headers
	}

	export default {
		name: 'ext-redir-page',
		data: function () {
			return {
				apiError: false,
				infoFetched: false,
				infoFetching: true,
				speedbumpDisplayed: false,
				speedbumpItems: [],
				speedbumpDescription: '',
				partner: null,
				beneficiary: null,
				redirectUrl: false,
				redirPage,
				user: null,
				staticUrl: window.FM.STATIC_URL || '',
				bookmarkStep1: false,
				bookmarkStep2: false,
				bookmarkButton: (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'CMD' : 'CTRL'),
				bookmarkPartner: 937,
				utm_campaign: null,
				adblockDetected: false,
				adblockForced: false
			}
		},
		methods: {
			adblockDetect: async() => {
				const baitUrls = [
					//'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
					//'https://connect.facebook.net/pl_PL/fbevents.js',
					//'https://c.amazon-adsystem.com/e/dtb/bid',
					//'https://www.googletagservices.com/tag/js/gpt.js',
					//'https://static.hotjar.com/c/hotjar-0.js',
					//'https://cdn.branch.io/branch-latest.min.js',
					'https://adblock.fanimani.pl/adserwer.js'
				];
		
				for (const baitUrl of baitUrls) {
					try {
						const response = await fetch(baitUrl, {
						method: 'HEAD',
						mode: 'no-cors',
						cache: 'no-store'
					});
					} catch (error) {
						//console.log('not loaded')
						const response = fetch("https://adblock.fanimani.pl/log/", {
						method: "POST",
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							'browser': window.navigator.userAgent,
							'url': baitUrl
						})
						});
						return true;
					}
				}
			},
			fetchRedirectInfo: function () {
				// Pick partner and deep link from url and convey them to API
				let { partner, destination, beneficiary_id, utm_source, utm_medium, utm_campaign } = queryString.parse(location.search)
				let url = '/api/v2/partner-redirect-info/' + partner + '/'
				let redirReqParams = queryString.stringify({destination, beneficiary_id})
				if (redirReqParams) {
					url = url + '?' + redirReqParams
				}

				if(utm_source){
					Cookies.set('utm_source', utm_source);
				}
				if(utm_medium){
					Cookies.set('utm_medium', utm_medium);
				}

				if(utm_campaign){
					Cookies.set('utm_campaign', utm_campaign);
					this.utm_campaign = utm_campaign;
				}

				this.infoFetching = true
				return fetch(url, {
					credentials: 'include',
					headers: getDefaultHeaders()
				}).then(response => {
					// Check status and throw error if not 200-ish
					if (response.status >= 200 && response.status < 300) {
						return response
					} else {
						let error = new Error(response.status + ": " + response.statusText)
						error.response = response
						throw error
					}
				})
				.then(response => {
					// And if there's no error, then return JSON
					console.log('Will return json')
					return response.json()
				})
				.catch(ex => {
					this.infoFetching = false
					this.infoFetched = false
					this.apiError = true
					console.log('fetching or parsing failed', ex)
					throw ex
				})
			},
			adblockRefresh: function () {
				window.location.reload();
			},
			adblockForce: function(){
				this.adblockDetected = false;
				this.adblockForced = true;
				this.fetchRedirectInfo()
				.then(data => {
					this.shopclickHandle(data);
				})
				.catch(error => {
					this.apiError = true
					this.infoFetching = true
					if (error.response && error.response.status) {
						this.apiError = error.response.status
					}
				})
			},
			redirectToPartner: function (timeout=2000) {
				let { debug } = queryString.parse(location.search)
				// wait 2 secs and redirect to shop
				var this2=this;
				this.postClickthroughData();
				
				if(typeof(debug)=='undefined'){
				setTimeout(function () {
					console.log("Redirecting to shop... " + this2.redirectUrl)
					window.location = encodeURI(this2.redirectUrl)
				}, timeout)
				}
			},

			speedbumpAcknowledge: function(event){
				event.preventDefault();
				Cookies.set('partner_'+this.partner.id+'_speedbump', 1, { expires: 7 })
				clickthrough['partner_id']=this.partner.id;
				clickthrough['partner']=this.partner;
				clickthrough['beneficiary']=this.beneficiary;
				clickthrough['user']=this.user;
				this.redirectToPartner(100);
			},

			postClickthroughData: function(){
				try{
					window.postMessage(
						{
							action: "fanimaniExtensionClickthrough",
							data: JSON.parse(JSON.stringify(clickthrough))
						}, "*"
					);
				} catch(e){
					console.log('postClickthroughData() error')
					console.log(e)
					console.log(JSON.parse(JSON.stringify(clickthrough)))
				}
			},

			bookmarkGoToStep2: function(event){
				document.body.classList.add('partner-modal-bookmark-step2');
				try{
					let bookmarkUrl = new URL(window.location.href);
					bookmarkUrl.searchParams.set('utm_campaign', 'bookmark');
					history.pushState({}, "", bookmarkUrl);
				} catch (e) {
					console.log('bookmarkGoToStep2() error');
				}
				this.bookmarkStep1 = false;
				this.bookmarkStep2 = true;
			},
			shopclickHandle: function(data){
				// FIXME: For some reason this handler gets called also if the promose resulted with an error
				// So exit programatically if there's no data (was error)
				if (typeof(data) === 'undefined') {
					return
				}

				let { debug } = queryString.parse(location.search)

				if(typeof(debug)!='undefined'){
					console.log('fetchRedirectInfo():');
					console.log(data);
				}

				this.partner = data.partner
				this.beneficiary = data.beneficiary
				this.user = data.user

				this.infoFetched = true
				this.infoFetching = false
				
				this.redirectUrl = data.redirect_url

				if(this.partner){
					document.title=this.partner.name+' - AKTYWUJ DAROWIZNĘ - FaniMani.pl';
				}

				if(data.partner.speedbump_visible){
					var speedbumpCookie=Cookies.get('partner_'+data.partner.id+'_speedbump');
					if(speedbumpCookie || this.utm_campaign=='bookmark' || (redirPage=='mobile' && data.partner.id==this.bookmarkPartner)){
						clickthrough['partner_id']=this.partner.id;
						clickthrough['partner']=this.partner;
						clickthrough['beneficiary']=this.beneficiary;
						clickthrough['user']=this.user;
						this.redirectToPartner();  
					} else {
						if(data.partner.id==this.bookmarkPartner){
							this.bookmarkStep1 = true;
						}
						this.speedbumpDisplayed = true;
						this.speedbumpItems = data.partner.speedbump_description.split(/\r\n|\n|\r/);
						this.speedbumpDescription = data.partner.speedbump_description;
					}
				} else {
					clickthrough['partner_id']=this.partner.id;
					clickthrough['partner']=this.partner;
					clickthrough['beneficiary']=this.beneficiary;
					clickthrough['user']=this.user;
					this.redirectToPartner();  
				}
			}
		},
		mounted: function () {
			this.adblockDetect().then((adblockDetectResults) => {
				if(adblockDetectResults){
					this.adblockDetected = true;
					console.log('adblock detected')
				} else {
					console.log('adblock not detected')
					this.fetchRedirectInfo()
					.then(data => {
						this.shopclickHandle(data);
					})
					.catch(error => {
						this.apiError = true
						this.infoFetching = true
						if (error.response && error.response.status) {
							this.apiError = error.response.status
						}
					})
				}
			});
		}
	}
</script>
